/* eslint-disable eqeqeq */
import React, {  } from 'react';
import { Outlet/* , useParams */ } from "react-router-dom";
import {
    Box,
} from '@mui/material';
import Header from "./components/Header";
import Breadcrumbs from "./components/Breadcrumbs";
// import Footer from "./components/Footer";
import './Main.css';

const Main = (props) => {
  // const { orgId } = useParams();

  return (
    <Box component="section" className="mainLayoutBox">
      <Header />
      <Breadcrumbs />
      <main>
        <Outlet />
      </main>
      {/* {orgId == "938125692074" && (
        <Footer />
      )} */}
    </Box>
  );
};

Main.propTypes = {
  
};

export default Main;
